import React from "react";
import { Tooltip } from "@evergis/ui";
import { NonEditableField as NonEditableFieldUI, NonEditableNumber as NonEditableNumberUI } from "./styled";
import { formatNumber } from "../../../../../../utils/formatNumber";
import { formatDate } from "../../../../../../utils/date";

interface NonEditableFieldProps {
  value: string | number;
  stringLimit?: number;
  defaultValue?: string;
  tooltipContent?: string;
  uniqueField?: boolean;
  maxWidth?: string;
  isDate?: boolean;
}

const TOOLTIP_DELAY = 300;

export const TOOLTIP_DELAY_XY: [number, number] = [TOOLTIP_DELAY, TOOLTIP_DELAY];

export const NonEditableField = ({
  value,
  stringLimit,
  tooltipContent,
  defaultValue = "",
  uniqueField,
  maxWidth,
  isDate,
}: NonEditableFieldProps) => {
  const isNumber = typeof value === "number";
  const NonEditableFieldElement = isNumber ? NonEditableNumberUI : NonEditableFieldUI;
  const content = isDate ? formatDate(value) : isNumber ? formatNumber(value as number) : value.toString();

  return content.length < stringLimit ? (
    <NonEditableFieldElement maxWidth={maxWidth} uniqueField={uniqueField}>
      {content || defaultValue}
    </NonEditableFieldElement>
  ) : (
    <Tooltip
      flip={false}
      distance={22}
      arrow
      placement={"top"}
      content={tooltipContent || content}
      delay={TOOLTIP_DELAY_XY}
    >
      {ref => (
        <NonEditableFieldElement maxWidth={maxWidth} uniqueField={uniqueField} ref={ref}>
          {content || defaultValue}
        </NonEditableFieldElement>
      )}
    </Tooltip>
  );
};
